import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export class MultiTranslateHttpLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private resources: { prefix: string; suffix: string }[] = [
      { prefix: './assets/i18n/', suffix: '.json' },
      { prefix: './assets/i18n/pipes/relative-time.', suffix: '.json' }
    ]
  ) {}

  getTranslation(lang: string): Observable<any> {
    const requests = this.resources.map(resource => {
      const path = `${resource.prefix}${lang}${resource.suffix}`;
      return this.http.get(path).pipe(catchError(() => of({})));
    });

    return forkJoin(requests).pipe(
      map(responses => {
        return responses.reduce((acc, response) => {
          return this.deepMerge(acc, response);
        }, {});
      })
    );
  }

  private deepMerge(target: any, source: any): any {
    const output = { ...target };

    if (this.isObject(target) && this.isObject(source)) {
      Object.keys(source).forEach(key => {
        if (this.isObject(source[key])) {
          if (!(key in target)) {
            output[key] = source[key];
          } else {
            output[key] = this.deepMerge(target[key], source[key]);
          }
        } else {
          output[key] = source[key];
        }
      });
    }

    return output;
  }

  private isObject(item: any): boolean {
    return item && typeof item === 'object' && !Array.isArray(item);
  }
}
